import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'price-text',
  templateUrl: './price-text.component.html',
  styleUrls: ['./price-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PriceTextComponent {
  @Input() price;
  @Input() discountedPrice;
  @Input() currency;

  get discountExists() {
    return (
      this.discountedPrice !== undefined &&
      this.discountedPrice !== null &&
      this.price !== this.discountedPrice
    );
  }
}
